import * as reservation_types from "../../types/reservation_types";

const initialState = {
  loading: false,
  error: "",
  success: "",
  reservations: [],
};

export const reservation_reducers = (state = initialState, action) => {
  switch (action.type) {
    case reservation_types.RESERVE_VEHICLE_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case reservation_types.RESERVE_VEHICLE_SUCCESS:
      return {
        ...state,
        loading: false,
        success: "Reservation created successfully",
        error: "",
      };

    case reservation_types.RESERVE_VEHICLE_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
        success: "",
      };
    default:
      return {
        ...state,
      };
  }
};
